export function secsToPace(secs) {
    var seconds = Math.floor(secs);
    return new Date(seconds * 1000).toISOString().substr(14, 5);
}


export function convertToSecs(time) {
    return time.split(':').reverse().reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0)
}